import { useEffect, useState, useContext,  useMemo} from 'react'; // useMemo pour Table.jsx
import {Link, useNavigate } from "react-router-dom";

import { DonneesUtilisateurContext } from '../../contexte.js';

import { apiRecupereInfoGet } from '../../Datas/datasAutre.js'
import { apiPcfSuppr } from '../../Datas/dataPcf.js'

import ButtonDeBase, { ButtonSuppr, ButtonVoirFiche } from '../../Components/ButtonsCustom.jsx';
import LoadingSpinner from "../../Components/LoadingSpinner";
import MessageInfoBox, {MessageErreurApi} from '../../Components/Messages.jsx';
import Table from '../../Components/Table.jsx';



/**
 * Return contacts
 *
 * @component
 * @summary utlisé page contacts LieuxEtContacts pour lister tout les lieux et contacts
 * @param {  }
 * @return { HTMLElement }
*/
function ListeContacts(props) {
    const navigate = useNavigate(); // utile pour changer de page
    const { utilisateurBearer } = useContext(DonneesUtilisateurContext);
    const [dataApi, setDataApi] = useState();
    const [dataLoaded, setDataLoaded] = useState(true);
    const [messageProbleme, setMessageProbleme] = useState();

   function  hdleClickNoPossible () {
      alert("Impossible de supprimer cette personne car elle est référencée dans certaines formations");
   }

    //pour react-table https://stackoverflow.com/questions/56922381/how-to-include-url-in-react-table-cell
    const columns = useMemo(
        () => [
          {
            id:'listesContacts',
            hideHeader : false,
            trieDefautRp : 'PERSONS_LAST_NAME',
            columns: [
                { 
                  Header: 'Nom', 
                  accessor: 'PERSONS_LAST_NAME',
                },
                { 
                    Header: 'Prénom', 
                    accessor: 'PERSONS_FIRST_NAME',
                },
                { 
                  Header: 'Téléphone fixe', 
                  accessor: 'PERSONS_TELFIXE',
                },
                { 
                    Header: 'Mobile', 
                    accessor: 'PERSONS_TELMOBILE',
                },
                { 
                  Header: 'Courriel', 
                  accessor: 'PERSONS_COURRIEL',
                },


                { 
                  Header: 'Adresse', 
                  accessor: 'ADDRESS1',
                  id: "ADDRESS1_secondaires"
                },
                {  
                  Header: 'Code postal', 
                  accessor: 'CODE_POSTAL',
                  id: "CODE_POSTAL_secondaires"
                },
                { 
                  Header: 'Ville', 
                  accessor: 'LIB_GEO_VILLES',
                  id: "LIB_GEO_VILLES_secondaires"
                },


                {
                  Header: () => <></>,
                    accessor: 'actions', 
                    id: "asso_center",
                    disableSortBy: true,
                    Cell: ({ row }) => (
                        <>
                          <Link title={`Accéder à la fiche ${row.original.ID_PERSONS}`} to={`/lieux-et-contacts/edition-contact/${row.original.ID_PERSONS}`}>
                            <ButtonVoirFiche className="fas fa-pen-to-square" />
                          </Link>
                          {row.original.est_utilise == false ?
                            <a title={`Supprimer ${row.original.ID_PCF}`} onClick={() => handleClickSupprContact(row.original.ID_PCF)}>
                              <ButtonSuppr />
                            </a>
                            :
                            <a title="Suppression impossible" onClick={() => hdleClickNoPossible()}>
                              <ButtonSuppr disabled="disabled"  />
                            </a>
                          }
                        </>
                    ),
                },
            ]
          },
        ],
        []
    )
 

    const handleClickSupprContact  = async (codePcf) => {
        setDataLoaded(false);
        setMessageProbleme();
        var dataR = await apiPcfSuppr(utilisateurBearer, codePcf, 'contact');

        switch (dataR.statusCode) {
            case 204 :
                await recupContacts(); // reload la liste
                alert("La suppression a bien été effectuée");
                
              break;
            case 401:
                setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
              break;
            default:
                setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
        }
        setDataLoaded(true);
    }

    
    async function recupContacts() {
        setDataLoaded(false);
        const dataR = await apiRecupereInfoGet(utilisateurBearer, "persons/contacts-liste");
        if(global.config.modeDebugApp == 1) console.log(`retour apiRecupereInfoGet avec "persons/contacts-liste" : `, dataR);

        switch (dataR.statusCode) {
            case 200:
                setDataApi(dataR.dataApi);
              break;
            case 401:
                setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
              break;
            default:
                setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
        }
        setDataLoaded(true);
    }
    const handleClickCreatePerson = () => {
      navigate(`/lieux-et-contacts/creation-personne`);
    }

    useEffect(() => {
      if(global.config.modeDebugApp == 1)  console.log('useffect ListeContacts')
      recupContacts();
    }, []);
   
   var messageInfo = "Les contacts déclarés ici servent à renseigner vos formations";
    return (
        <>
          <LoadingSpinner dataLoaded={dataLoaded} />
          <MessageErreurApi message={messageProbleme} />

          {dataLoaded &&
          <>
            <section>
                <br />
                {dataApi && dataApi.length > 1 && <MessageInfoBox message={messageInfo} />}
                Cliquez sur le <span className="fas fa-pen-to-square picto-legende"></span> pour modifier les informations du contact souhaité et gérer les lieux où il est positionné.
                {dataApi && dataApi.length > 0 && 
                    <Table columns={columns} data={dataApi} noFilter={false} />
                }
                {dataApi && dataApi.length == 0 && <div>Aucune personne n'a encore été déclarée.</div>}
            </section>
            <div className="centrage-deux-elements">
              <div className="align-div-right ">Une personne manquante ?</div>
              {/*<div className="align-div-right ">Une coordonnées <span style={{fontSize: "2em"}}>🏫</span>ou une personne 🤵 manquante ?</div> */} 
                <div className="align-div-left">
                <ButtonDeBase onClick={handleClickCreatePerson} lib="Ajouter un contact 🤵" />
                </div>
            </div>
          </>
          }

        </>
    )

}

export default ListeContacts;